"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setPatientDetails = setPatientDetails;
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
// eslint-disable-next-line import/prefer-default-export
function setPatientDetails(actionContext, payload) {
  actionContext.dispatch('SET_PATIENT_DETAILS_FINISH', payload);
}
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(setPatientDetails, "setPatientDetails", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/actions/patient-summary.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJzZXRQYXRpZW50RGV0YWlscyIsImFjdGlvbkNvbnRleHQiLCJwYXlsb2FkIiwiZGlzcGF0Y2giXSwic291cmNlcyI6WyIuLi8uLi9zcmMvYWN0aW9ucy9wYXRpZW50LXN1bW1hcnkuanMiXSwic291cmNlc0NvbnRlbnQiOlsiLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIGltcG9ydC9wcmVmZXItZGVmYXVsdC1leHBvcnRcbmV4cG9ydCBmdW5jdGlvbiBzZXRQYXRpZW50RGV0YWlscyhhY3Rpb25Db250ZXh0LCBwYXlsb2FkKSB7XG5cdGFjdGlvbkNvbnRleHQuZGlzcGF0Y2goJ1NFVF9QQVRJRU5UX0RFVEFJTFNfRklOSVNIJywgcGF5bG9hZCk7XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7QUFBQTtBQUNPLFNBQVNBLGlCQUFpQixDQUFDQyxhQUFhLEVBQUVDLE9BQU8sRUFBRTtFQUN6REQsYUFBYSxDQUFDRSxRQUFRLENBQUMsNEJBQTRCLEVBQUVELE9BQU8sQ0FBQztBQUM5RDtBQUFDO0FBQUE7RUFBQTtFQUFBO0lBQUE7RUFBQTtFQUFBLHdCQUZlRixpQkFBaUI7QUFBQTtBQUFBO0FBQUE7RUFBQTtFQUFBO0FBQUEifQ==